interface Estado {
  id: number;
  nome: string;
}

interface Municipio {
  id: number;
  nome: string;
}

interface Area {
  id: number;
  nome: string;
}

interface Tipo {
  id: number;
  nome: string;
}

interface AgenteRegulado {
  id: number;
  nome: string;
}

interface Contato {
  id: number;
  data: string;
  origemMensagem: string;
  destinoMensagem: string;
  mensagem: string;
}

export default class Solicitacao {
  constructor(
    public id?: number,
    public solicitanteNome?: string,
    public email?: string,
    public telefone?: string,
    public endereco?: string,
    public cep?: string,
    public municipio?: Municipio,
    public estado?: Estado,
    public area?: Area,
    public tipo?: Tipo,
    public agenteRegulado?: AgenteRegulado,
    public entrouEmContato?: boolean,
    public unidadeConsumidoraNumero?: string,
    public viagemHoraDeInicio?: string,
    public viagemLocalDeInicio?: string,
    public viagemLocalDeFim?: string,
    public viagemNomeDaLinha?: string,
    public pretensao?: string,
    public recaptcha?: string,
    public contatos?: Contato[]
  ) {}
}
